var $09cd168ab18773f4$exports = {};
$09cd168ab18773f4$exports = {
  "removeButtonLabel": "\u79FB\u9664",
  "removeDescription": "\u6309 Delete \u9375\u4EE5\u79FB\u9664\u6A19\u8A18\u3002"
};
export { $09cd168ab18773f4$exports as default };